module.exports = __webpack_public_path__ + "img/icon_02.eef68765.png";